import firebase from "firebase";
import { firebaseAuth } from "../firebase/firebaseAuth";
import firestore from "../firebase/firestore";
import { getPEOPLE } from "../services/getPeople";
import { createCustomer } from "../services/pagarme";
import store from "../store";
import api from "../utils/api";
import { getBillingsByUserOpened } from "./billing";
import { getConsumerUnits } from "./consumer_units";

export const changeEmail = (user_id, new_email) =>
  api.post(process.env.VUE_APP_CHANGEEMAIL + "/" + user_id + "/changeemail", {
    new_email,
  });

export const changeLeadEmail = (user_id, new_email) =>
  api.post(
    process.env.VUE_APP_LEAD_CHANGEEMAIL + "/" + user_id + "/changeemail",
    { new_email },
  );

export const storeCustomer = (user) =>
  api.post(process.env.VUE_APP_CREATE_CUSTOMER, user);

export const getUser = (customer_id) => {
  return firestore.doc(`users/${customer_id}`).get();
};

export const getUserByEmail = (email) => {
  return firestore
    .collection("users")
    .where("email", "==", email)
    .limit(1)
    .get();
};

export const getUserByCPF = (cpf) => {
  return firestore.collection("users").where("cpf", "==", cpf).limit(1).get();
};

export const getUserById = (id) => {
  return firestore.collection("users").doc(id).get();
};

export const getSellers = (partner_id) => {
  let q = firestore
    .collection("users")
    .where("group", "array-contains-any", [
      "sales_partner",
      "sales_partner_management",
      "sales",
      "sales_management",
    ]);
  if (partner_id) q = q.where("partner_id", "==", partner_id);
  q = q.orderBy("name", "asc").get();
  return q;
};

export const getPartnerSellers = () => {
  return firestore
    .collection("users")
    .where("group", "array-contains-any", [
      "sales_partner",
      "sales_partner_management",
    ])
    .orderBy("name", "asc")
    .get();
};

export const getObligations = (customer_id) => {
  return firestore
    .collection("billing")
    .where("customer_id", "==", customer_id)
    .where("status", "in", ["refused", "waiting_payment", "opened", "overdue"])
    .get();
};

export const downloadContracts = (customer_id) => {
  return firestore
    .collection("users")
    .doc(customer_id)
    .collection("contracts")
    .get()
    .then((contracts) => {
      return contracts.docs.map((contract) => {
        return { id: contract.id, ...contract.data() };
      });
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};

export const sendContractsEmail = (user_id, email) =>
  api.post(process.env.VUE_APP_SENDCONTRACTSEMAIL, { user_id, email });

export const getUserObject = (customer_id) => {
  return firestore
    .doc(`users/${customer_id}`)
    .get()
    .then((result) => result.data());
};

export const getUsers = (args) => {
  let ref = firestore.collection("users");
  if (args.searchBy) {
    ref = ref.where(
      args.searchBy.field,
      args.searchBy.operator,
      args.searchBy.value,
    );
    if (args.searchBy.operator !== "==")
      ref = ref.orderBy(args.searchBy.field, "asc");
  } else if (args.orderBy) {
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  } else if (args.orderBy) {
    ref = ref.orderBy(args.orderBy.field, args.orderBy.direction);
  }
  if (args.limit && args.page) {
    ref = ref.limit(args.limit);
    ref = ref.offset(args.page * args.limit - args.limit);
  }

  return ref;
};

export const updateUser = async (id, user) => {
  const ref = firestore.doc(`users/${id}`);
  user.updated_at = new Date();
  return ref
    .update(user)
    .then(async () => {
      return await ref.get();
    })
    .catch((err) => {
      console.error("Erro ao atualizar o usuário", err);
      return null;
    });
};

export const cancelCustomer = (user) =>
  api.post(process.env.VUE_APP_CANCEL_CUSTOMER, user);

export const cancelUser = async (user) => {
  return cancelCustomer(user);
};

export const reactivateCustomer = (user) =>
  api.post(process.env.VUE_APP_REACTIVATE_CUSTOMER, user);

export const createUser = (uid, user) => {
  user.updated_at = new Date();
  user.created_at = new Date();
  if (uid) {
    const ref = firestore.collection("users");
    return ref.doc(uid).set(user);
  } else {
    const ref = firestore.collection("users");
    return ref.add(user);
  }
};

export const storeUser = async (data) => {
  if (!data.email && !data.cpf) return false;
  let users = await getUserByEmail(data.email);
  if (users.docs.length > 0) {
    const user = users.docs[0];
    return updateUser(user.id, data);
  } else {
    //Criar usuário no auth
    let newUserAuth = await createAuthUser(data);
    if (newUserAuth.user.uid) {
      //Criar usuario no pagarme
      let userPagarme = await createCustomer(data);
      if (userPagarme.data.id) {
        //criar usuario no banco de dados
        let newUser = {
          name: data.name,
          email: data.email,
          buyer_id: userPagarme.data.id,
          phone: data.phone,
          group: data.group,
          status: data.status,
          address: {
            address: data.logradouro || "",
            address_number: data.numero || "",
            address_complement: data.complemento || "",
            district: data.bairro || "",
            postal_code: data.cep || "",
            state: data.state,
            city: data.localidade,
            country: data.country,
          },
          average_consumption: data.average,
          cpf: data.cpf,
          customer_id: newUserAuth.user.uid,
          date_of_birth: data.birthday,
          gender: data.gender,
          installation_number: data.consumer_unit,
          installation_numbers: data.installation_numbers,
          nationality: data.nacionalidade,
          payment_type: data.payment_type,
          profession: data.profissao,
          mother_name: data.mother_name,
          requiredPSChange: data.requiredPSChange,
          termouso: data.termo_uso,
          signedcontract_at: data.signedcontract_at,
          marital_status: data.marital_status_value,
          marital_type: data.marital_type_value,
        };

        const createUser = await createUser(newUserAuth.user.uid, newUser);
        return {
          id: createUser.uid,
          ...newUser,
        };
      }
    } else {
      return "Erro ao criar usuário. Entrar em contato com o suporte";
    }
  }
};

export const getMember = async (param, type) => {
  if (type === "email") {
    let lead = await firestore.collection("leads").doc(param).get();
    let user = await firestore
      .collection("users")
      .where("email", "==", param)
      .get();
    if (user.empty) {
      if (!lead.exists) return null;
      let new_lead = { id: lead.id, ...lead.data() };
      return new_lead;
    } else {
      let new_user = { id: user.docs[0].id, ...user.docs[0].data() };
      let new_lead = { id: lead.id, ...lead.data(), user: new_user };
      return new_lead;
    }
  } else if (type === "cpf") {
    let user = await firestore
      .collection("users")
      .where("cpf", "==", param)
      .get();
    if (user.empty) {
      let lead = await firestore
        .collection("leads")
        .where("cpf", "==", param)
        .limit(1)
        .get();
      if (lead.size <= 0) return null;
      let new_lead = { id: lead.docs[0].id, ...lead.docs[0].data() };
      return new_lead;
    } else {
      let new_user = { id: user.docs[0].id, ...user.docs[0].data() };
      let new_lead = {
        id: new_user.email,
        ...user.docs[0].data(),
        user: new_user,
      };
      return new_lead;
    }
  } else {
    return null;
  }
};

export const createAuthUser = (data) => {
  return firebaseAuth.createUserWithEmailAndPassword(data.email, data.cpf);
};

export const saveUser = async (data) => {
  let userFb;
  let auth_usr = {
    email: data.email,
    cpf: data.cpf,
  };
  let user = await createAuthUser(auth_usr);
  if (!user.user.uid) return { error: user };
  userFb = await getUserById(user.user.uid);

  if (userFb && userFb.exists && userFb.id) {
    //Se já existir o usuário irá atualizalo
    updateUser(user.user.uid, data)
      .then(() => {
        return {
          id: user.user.uid,
          ...data,
        };
      })
      .catch((err) => {
        console.error(err.message);
        return { error: err };
      });
  } else {
    //Se não existir cria um usuário
    createUser(user.user.uid, data)
      .then(() => {
        return {
          id: user.user.uid,
          ...data,
        };
      })
      .catch((err) => {
        console.error(err.message);
        return { error: err };
      });
  }
};

export const disableUser = (id) =>
  api.post(process.env.VUE_APP_DISABLE_USER, { id });
export const enableUser = (id) =>
  api.post(process.env.VUE_APP_ENABLE_USER, { id });

export const addUser = (data) => api.post(process.env.VUE_APP_ADD_USER, data);

export const validaCPF = (strCPF) => {
  if (!strCPF) return false;
  strCPF.replace(/[^\d]+/g, "");
  let Soma;
  let Resto;
  Soma = 0;
  if (strCPF == "00000000000") return false;
  if (strCPF == "11111111111") return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  return Resto == parseInt(strCPF.substring(10, 11));
};

export const validaCNPJ = (strCNPJ) => {
  if (!strCNPJ) return false;
  let cnpj = strCNPJ.replace(/[^\d]+/g, "");
  if (cnpj.length != 14) return false;

  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return resultado == digitos.charAt(1);
};

export const validaCPFNaBase = async (
  cpf,
  person_type,
  email,
  user,
  canSetQualification,
) => {
  let cpf_valid = false;
  let cpf_duplicated = false;
  let _canSubscription = true;
  let _ucs = [];
  let financial_pending = false;

  if (user?.customer_id) {
    cpf_valid = true;
    await canSubscription(user, canSetQualification).then((ret) => {
      _canSubscription = ret.canSubscription;
      _ucs = ret.ucs;
      financial_pending = ret.financial_pending;
    });
    cpf_duplicated = true;
    const email_found = user.email;
    const same_email =
      email_found?.toLowerCase() === email?.toLowerCase() ? true : false;
    return {
      cpf_valid,
      cpf_duplicated,
      email_found,
      same_email,
      can_subscription: _canSubscription,
      financial_pending,
      ucs: _ucs,
    };
  } else if (person_type === "pf" ? validaCPF(cpf) : validaCNPJ(cpf)) {
    cpf_valid = true;
    const ret = await firestore
      .collection("users")
      .where("cpf", "==", cpf)
      .limit(1)
      .get();
    if (ret?.size > 0) {
      if (!email)
        store.dispatch("sales/setUser", {
          id: ret.docs[0].id,
          ...ret.docs[0].data(),
        });
      await canSubscription(
        { id: ret.docs[0].id, ...ret.docs[0].data() },
        canSetQualification,
      ).then((ret) => {
        _canSubscription = ret.canSubscription;
        _ucs = ret.ucs;
        financial_pending = ret.financial_pending;
      });
      cpf_duplicated = true;
      const email_found = ret.docs[0].data().email;
      const same_email =
        email_found?.toLowerCase() === email?.toLowerCase() || !email
          ? true
          : false;
      return {
        cpf_valid,
        cpf_duplicated,
        email_found,
        same_email,
        can_subscription: _canSubscription,
        financial_pending,
        ucs: _ucs,
      };
    } else {
      return {
        cpf_valid,
        cpf_duplicated,
        same_email: false,
        can_subscription: _canSubscription,
        financial_pending,
      };
    }
  } else {
    return {
      cpf_valid,
      can_subscription: false,
      cpf_duplicated: false,
      financial_pending,
    };
  }
};

const canSubscription = async (user, canSetQualification) => {
  let args = {
    searchBy: {
      field: "user_id",
      operator: "==",
      value: user.customer_id,
    },
  };
  let _ucs = [];
  let financial_pending = false;
  let ucs = await getConsumerUnits(args).get();

  //Se não encontrou ucs pode vender
  if (ucs?.size <= 0) return { ucs: _ucs, canSubscription: true };

  //Se encontrou ucs verifica se não há pendencias financeiras
  for (let i = 0; i < ucs.size; i++) {
    _ucs.push({ id: ucs.docs[i].id, ...ucs.docs[i].data() });
  }
  if (canSetQualification) {
    store.commit("qualification/setQualifications", []);
    const qualificationsObj = _ucs.map((uc) => {
      return {
        consumer_unit: uc.id,
        utility_company: uc.utility_company,
        status: uc.status,
        consumer_unit_detail: {
          ...uc,
        },
      };
    });
    store.dispatch("qualification/pushQualificationsForm", qualificationsObj);
  }
  let contract_id = 0;

  // Verifica se há pendencias financeiras
  // Busca pendencias financeiras
  let billings = await getBillingsByUserOpened(user.id);
  if (billings?.size > 0) {
    financial_pending = true;
  }

  contract_id = await _ucs.reduce(async (sum, cur) => {
    if (cur.status === "activated") return sum++;
    if (
      cur.contract_id &&
      cur.contract_id !== "" &&
      cur.status !== "contract_not_signed" &&
      cur.status !== "canceled"
      // || cur.billing_competence_start
    ) {
      sum++;
      return sum;
    } else return sum;
  }, 0);

  if (
    user.signedcontract_by === "onboarding" &&
    user.signedcontract_source === "online" &&
    user.signedcontract_partner === "enercred" &&
    user.status === "ATIVO"
  )
    return { ucs: _ucs, canSubscription: false, financial_pending };

  // Se foi vendido por aplicatico e possui ucs e está com status ATIVO não pode revender
  if (
    user.signedcontract_by === "mobile_app" &&
    contract_id > 0 &&
    user.status === "ATIVO"
  ) {
    return { ucs: _ucs, canSubscription: false, financial_pending };
  }
  return { ucs: _ucs, canSubscription: contract_id <= 0, financial_pending };
};

export const getComplementaryData = (cpf) => {
  let complementary_data = null;
  return getPEOPLE(cpf)
    .then((result) => {
      if (result.data.BasicData) {
        complementary_data = {
          nome_titular: result.data.BasicData.Name || "",
          gender: result.data.BasicData.Gender || "",
          nacionalidade: result.data.BasicData.BirthCountry || "brasileiro(a)",
          mother_name: result.data.BasicData.MotherName || "",
          birthday: result.data.BasicData?.BirthDate,
        };
      }
      if (
        result.data.ProfessionData &&
        result.data.ProfessionData.TotalProfessions > 0
      ) {
        if (
          result.data.ProfessionData.Professions &&
          result.data.ProfessionData.Professions.length > 0
        ) {
          result.data.ProfessionData.Professions.forEach((t) => {
            if (t.Level !== "UNKNOWN") {
              complementary_data.profissao = t.Level;
            }
          });
        }
      }
      return complementary_data;
    })
    .catch((error) => {
      console.error(
        "CPF não encontrado na base de dados externa. Por favor, preencha os dados (Data nascimento, sexo, etc...) manualmente. Erro: " +
          error,
      );
      return complementary_data;
    });
};

export const deletePhoto = async (customer_id, id_photo, photo_origin) => {
  if (photo_origin == "uploads") {
    const document_data = {
      [id_photo]: firebase.firestore.FieldValue.delete(),
    };

    try {
      firestore.collection("users").doc(customer_id).update(document_data);
      return console.log("Documento deletado com sucesso");
    } catch (error) {
      return console.log("Documento não existe");
    }
  } else {
    try {
      const documentRef = firestore
        .collection("users")
        .doc(customer_id)
        .collection("document_photo")
        .doc(id_photo);

      const documentSnapshot = await documentRef.get();

      if (documentSnapshot.exists) {
        await documentRef.delete();
        return console.log("Documento deletado com sucesso");
      } else {
        return console.log("Documento não existe");
      }
    } catch (error) {
      console.error("Erro ao deletar documento:", error);
      throw error;
    }
  }
};

export const getLeadCredentials = (lead_id) =>
  api.post(process.env.VUE_APP_GET_LEAD_CREDENTIALS, { lead_id });

export async function updateUserCore(id, updateData) {
  return await api.put(process.env.VUE_APP_UPDATE_USER + id, updateData);
}

export async function getAllSellers() {
  const userRef = await firestore
    .collection("users")
    .where("group", "array-contains-any", [
      "sales",
      "sales_partner",
      "sales_management",
      "sales_partner_management",
    ])
    .get();

  const users = userRef.docs?.map((item) => item?.data());
  const activeUsers = users?.filter((item) => item.status == "ATIVO");

  return activeUsers;
}

export async function getUserChangelog(id) {
  const historyRef = await firestore
    .collection("users")
    .doc(id)
    .collection("changelog")
    .get();

  return historyRef.docs.map((history) => history.data());
}

export async function updateUserSeller(id, seller, observation) {
  try {
    const res = await updateUserCore(id, {
      change_reason: observation,
      seller: {
        signedcontract_by:
          (seller.partner_id ?? "enercred") == "enercred"
            ? "SUPER"
            : "Representante Comercial",
        signedcontract_partner: seller.email,
        signedcontract_source: seller.partner_id,
      },
    });

    if (res.data.code == "success") return true;
    else return false;
  } catch (error) {
    console.error(error);
    return false;
  }
}
